import React, { useState } from "react";
import { Megaphone, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "./ui/dialog";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Button } from "./ui/button";
import { Textarea } from "./ui/textarea";

// Gestor-only: send a manual notice/reminder to users.
export const NoticeSender = () => {
    const [open, setOpen] = useState(false);
    const [form, setForm] = useState({ title: "", message: "", target: "all" });
    const [sending, setSending] = useState(false);

    const send = async () => {
        if (!form.title || !form.message) { toast.error("Preencha título e mensagem"); return; }
        setSending(true);
        try {
            const { data } = await api.post("/notices", form);
            toast.success(`Aviso enviado para ${data.sent_to} pessoa(s)`);
            setOpen(false);
            setForm({ title: "", message: "", target: "all" });
        } catch (e) {
            toast.error(formatApiErrorDetail(e.response?.data?.detail));
        } finally {
            setSending(false);
        }
    };

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>
                <button data-testid="notice-sender-btn" className="rounded-xl p-2 text-foreground/70 transition-colors hover:bg-muted" title="Enviar aviso">
                    <Megaphone className="h-5 w-5" />
                </button>
            </DialogTrigger>
            <DialogContent className="rounded-2xl sm:max-w-md">
                <DialogHeader><DialogTitle className="font-heading text-2xl font-medium">Enviar aviso</DialogTitle></DialogHeader>
                <div className="space-y-4">
                    <div>
                        <Label>Destinatários</Label>
                        <select data-testid="notice-target" value={form.target} onChange={(e) => setForm({ ...form, target: e.target.value })} className="mt-1 w-full rounded-xl border border-input bg-background px-3 py-2 text-sm">
                            <option value="all">Todos</option>
                            <option value="colaboradores">Colaboradores</option>
                            <option value="gestores">Gestores</option>
                        </select>
                    </div>
                    <div>
                        <Label>Título</Label>
                        <Input data-testid="notice-title" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} className="mt-1 rounded-xl" placeholder="Ex: Reunião amanhã" />
                    </div>
                    <div>
                        <Label>Mensagem</Label>
                        <Textarea data-testid="notice-message" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} rows={3} className="mt-1 rounded-xl" placeholder="Escreva o aviso..." />
                    </div>
                    <Button onClick={send} disabled={sending} className="w-full rounded-full" data-testid="notice-send-btn">
                        {sending && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Enviar aviso
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};
